<template>
    <div class="integration-item border rounded shadow-sm my-3 p-3">
        <!-- Header Row -->
        <div class="flex items-center justify-between">
            <div class="flex items-center">
                <img :src="logo" :alt="`${title} logo`" class="w-10 h-10 mr-4" />
                <div>
                    <div class="flex items-center">
                        <span class="text-lg font-medium">{{ title }}</span>
                        <CheckCircleIcon v-if="isConnected" class="h-5 w-5 text-green-700 ml-2" />
                    </div>
                    <div class="text-sm text-gray-600 italic">Redirect Integration</div>
                </div>
            </div>
            <!-- Action Button in header row -->
            <div class="flex items-center">
                <div v-if="loading" class="mr-2">
                    <HalfCircleSpinner :loading="true" />
                </div>
                <button
                    @click="toggleConnection"
                    :disabled="loading"
                    :class="[
                        'px-4 py-2 font-medium transition text-white rounded-lg',
                        isConnected ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'
                    ]">
                    {{ isConnected ? 'Disconnect' : 'Connect' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import HalfCircleSpinner from '../../global/loader/HalfCircleSpinner.vue';
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import * as notificationsApi from '../../../api/notifications.api';

export default {
    name: 'RedirectIntegrationType',
    components: {
        HalfCircleSpinner,
        CheckCircleIcon
    },
    props: {
        title: { type: String, required: true },
        logo: { type: String, required: true },
        isConnected: { type: Boolean, default: false },
        url: { type: String, default: null },
        subscriberId: { type: String, default: null },
        providerId: { type: String, default: null },
        isPolling: { type: Boolean, default: false }
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        async toggleConnection() {
            this.loading = true;
            try {
                const connected = !this.isConnected;
                if (connected && this.url) {
                    // Connect: open URL in new tab
                    window.open(this.url, '_blank');
                    this.$emit('update:subscriber', null);
                } else if (!connected && this.url) {
                    // Disconnect: remove credentials
                    await notificationsApi.deleteSubscriberCredentials(this.subscriberId, this.providerId);
                    this.$emit('update:isConnected', false);
                }
            } catch (error) {
                console.error('Error toggling redirect connection:', error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.integration-item {
    margin: 1rem 0;
    padding: 1rem;
}
</style>
